import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandReykjavik(props: IconProps) {
  return (
    <BaseIcon size={40} viewBox="0 0 40 40" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 4H30.8054V23.169L30.799 23.2108C29.8297 29.5604 25.3571 33.5225 20.6131 35.8848L20.3818 36L20.1444 35.8978C19.3431 35.553 17.0711 34.3551 14.8711 32.272C12.6687 30.1866 10.5009 27.1773 10.0043 23.215L10 23.1805V23.1457H10.5573C10 23.1457 10 23.1457 10 23.1457V4Z"
        fill="white"
      />
      <path
        d="M14.0919 11.6848L12.3052 10.4874L10.5566 11.6848V4.55737H14.0729V7.48438H17.2279V4.55737H23.5571V7.48438H26.7122V4.55737H30.2474V11.6848L28.4988 10.4874L26.7122 11.6848V9.06193H23.5571V11.7038L21.7705 10.4874L20.383 11.4948L19.0526 10.4874L17.266 11.7038V9.06193H14.0919V11.6848Z"
        fill="#0376E1"
      />
      <path
        d="M28.48 12.2931L26.6934 13.4525V15.2581L28.48 14.0607L30.2286 15.2581V13.4525L28.48 12.2931Z"
        fill="#0376E1"
      />
      <path
        d="M19.0337 12.312L20.3832 13.3004L21.7706 12.312L23.5382 13.5094V15.3341L21.7516 14.1176L20.3641 15.125L19.0337 14.1176L17.2471 15.3341V13.5094L19.0337 12.312Z"
        fill="#0376E1"
      />
      <path
        d="M26.6934 18.8503V17.0447L28.48 15.9043L30.2286 17.0637V18.8503L28.48 17.6529L26.6934 18.8503Z"
        fill="#0376E1"
      />
      <path
        d="M12.3052 17.6529L14.0919 18.8503V17.0447L12.3052 15.8853L10.5566 17.0447V18.8313L12.3052 17.6529Z"
        fill="#0376E1"
      />
      <path
        d="M14.0729 13.4525V15.2581L12.3052 14.0607L10.5566 15.2391V13.4525L12.2862 12.2931L14.0729 13.4525Z"
        fill="#0376E1"
      />
      <path
        d="M28.48 19.4585L26.6934 20.6179V30.6153C28.594 28.4676 29.9625 25.8827 30.2096 23.1458V20.5989L28.48 19.4585Z"
        fill="#0376E1"
      />
      <path
        d="M12.2862 19.4585L14.0729 20.6179V30.6534C12.1722 28.4866 10.8037 25.9017 10.5566 23.1458V20.6179L12.2862 19.4585Z"
        fill="#0376E1"
      />
      <path
        d="M23.5377 20.808L21.7701 19.6106L20.4016 20.5989L19.0332 19.6106L17.2465 20.808L17.2275 33.5234C18.2349 34.2647 19.2993 34.8919 20.3636 35.386C21.447 34.8919 22.5304 34.2457 23.5567 33.4854L23.5377 20.808Z"
        fill="#0376E1"
      />
      <path
        d="M21.7702 15.9803L23.5378 17.1588L23.5568 19.0024L21.7702 17.767L20.3827 18.7743L19.0522 17.767L17.2656 19.0024V17.1778L19.0522 15.9803L20.4017 16.9687L21.7702 15.9803Z"
        fill="#0376E1"
      />
    </BaseIcon>
  );
}
